import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#arrow-down_svg__a)">
      <path d="M12 24a1 1 0 0 1-.71-.29l-9-9a1.004 1.004 0 0 1 1.42-1.42l8.29 8.3 8.29-8.3a1.004 1.004 0 1 1 1.42 1.42l-9 9A1 1 0 0 1 12 24" />
      <path d="M12 24a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v22a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="arrow-down_svg__a">
        <path fill="#fff" d="M2 0h20v24H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowDown;
